/*
  NOTE: IF CHANGING ANY STANDARD COLOR, PLEASE UPDATE THE VALUES ON utils/getPalleteColor
*/

const palette = {
  black: {
    standard: "#333333",
    dark: "#000000",
    black1: "#111111",
    black25: "#25282B",
  },
  white: {
    standard: "#FFFFFF",
    dark: "#DADADA",
    vanished: "#FAFAFA",
    whiteF3: "#F3F3F6",
  },
  orange: {
    standard: "#EB9700",
  },
  yellow: {
    standard: "#FEE400",
  },
  grey: {
    standard: "#CCCCCC",
    dark: "#666666",
    darkerStandard: "#999999",
    mid: "#ebebeb",
    light: "#F4F4F4",
    light5E: "#5E5E5E",
    lightF3: "#F3F3F6",
    grey5E: "#5E5E5E",
    greyAC: "#ACB3B8",
    greyEEE: "#EEEEEE",
    grey71: "#717171",
  },
  blue: {
    standard: "#53A9B8",
    dark: "#007C92",
    info: "#005EA5",
    blue006: "#0068E4",
  },
  red: {
    standard: "#E60000",
    status: "#BD0000",
    bannerE4: "#e41815",
    banner72: "#72150f",
  },
  semiTransparentBackground: {
    standard: "rgba(0, 0, 0, 0.5)",
  },
  green: {
    standard: "#009900",
    status: "#00BFA3",
  },
  bannerSubTitle: {
    textColor: "#1F140F",
  },
  bannerTitle: {
    textColor: "#1F140F",
  },
  copyRight: {
    textColor: "#FFFFFF",
  },
  footer: {
    bgColor: "#1F140F",
  },
  footerItem: {
    textColor: "#FFFFFF",
    bottomBorder: "#FFFFFF",
  },
  primaryButton: {
    textColor: "#FFFFFF",
    bgColor: "#1F140F",
  },
  upgradeButtonSecondary: {
    bgColor: "#355E72",
    textColor: "#FFFFFF",
  },
  goBackButton: {
    bgColor: "#FFFFFF",
    textColor: "#25282B",
    border: "#25282B",
  },
  OkBtn: {
    bgColor: "#25282B",
  },
  StyledBannerInfo: {
    color: "#111111",
  },
  TotalToday: {
    bgColor: "#F3F3F6",
    color: "#5E5E5E",
  },
  Amount: {
    color: "#25282B",
  },
  OkWhiteBtn: {
    bgColor: "#FFFFFF",
    color: "#25282B",
    border: "#25282B",
  },
  CostAfterTrialValue: {
    color: "#111111",
  },
  VodafoneMoreInfo: {
    color: "#25282B",
  },
  MoreInfo: {
    color: "#25282B",
  },
  SetupTitle: {
    color: "#111111",
  },
  CostAfterTrialText: {
    color: "#5E5E5E",
  },
  BasketCardGrey: {
    bgColor: "#F3F3F6",
  },
  TermsAndConditionsArea: {
    color: "#25282B",
  },
  SecondaryButton: {
    bgColor: "#666666",
    color: "#FFFFFF",
  },
  OutlineButton: {
    color: "#FFFFFF",
    border: "#FFFFFF",
  },
  OutlineButtonBordered: {
    color: "#25282B",
    border: "#25282B",
  },
  LinkButton: {
    color: "#25282B",
  },
  SignInGoogleButton: {
    bgColor: "#FFFFFF",
  },
  CheckboxText: {
    color: "#111111",
  },
  CreditCardContainer: {
    bgColor: "#F3F3F6",
  },
  CardSerialNumber: {
    color: "#111111",
  },
  CardExpireAt: {
    colorRed: "#E60000",
    colorBlack: "#111111",
  },
  SelectCreditCard: {
    color: "#111111",
  },
  CardEditContainer: {
    bgColor: "#ACB3B8",
  },
  SelectButton: {
    bgColor: "#25282B",
    border: "#25282B",
  },
  FooterContent: {
    bottomBorder: "#FFFFFF",
  },
  ErrorBallWrapper: {
    bgColor: "#E60000",
    stroke: "#FFFFFF",
  },
  SuccessBallWrapper: {
    bgColor: "#00BFA3",
    fill: "#FFFFFF",
  },
  WarningBallWrapper: {
    bgColor: "#BD0000",
    fill: "#FFFFFF",
  },
  InputContainer: {
    borderRed: "#E60000",
    borderBlack: "#111111",
    borderGrey: "#ACB3B8",
  },
  InputLabel: {
    color: "#5E5E5E",
  },
  getBackgroundColor: {
    bgColorRed: "#E60000",
    bgColorBlack: "#111111",
    bgColorBlue: "#0068E4",
    bgColorYellow: "#FEE400",
    bgColorWhite: "#F3F3F6",
  },
  getColor: {
    whiteStandard: "#FFFFFF",
    greenStatus: "#00BFA3",
    blackStandard: "#333333",
    redStandard: "#E60000",
  },
  Partner: {
    color: "#FFFFFF",
  },
  StyledServiceName: {
    color: "#333333",
  },
  Title: {
    color: "#111111",
  },
  Steps: {
    bgColor: "#F3F3F6",
  },
  StepText: {
    color: "#5E5E5E",
  },
};

export default palette;
